import '@/css/app.css'
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import './cookie-consent-mode.js'
import './base/revealOnScroll.js'
import './base/parallax.js'
import './components/osmo/carousel.js'
import './components/osmo/stacking-cards.js'
import './components/osmo/sticky-cards.js'
import './components/osmo/image-preview-cursor.js'
// import './components/osmo/vimeo-bg.js'
import './components/alert-dialog.js'
import './components/osmo/bunny.js'
import './components/osmo/bunny-lightbox.js'
import './components/osmo/scroll-progress-bar.js'
import './components/osmo/change-title.js'

import { gsap } from 'gsap'

import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

import Lenis from 'lenis'
const offset = window.innerWidth > 1024 ? -160 : -140
console.log(offset, 'test')
const lenis = new Lenis({
    autoRaf: true,
    duration: 0.9,
    anchors: {
        offset: offset
    },
    prevent: (node) => {
        const classes = ['pm-wrapper']
        return classes.some((cls) => node.classList.contains(cls))
    }
})
lenis.on('scroll', () => ScrollTrigger.update())

// const anchors = document.querySelectorAll('a')
// anchors.forEach((a) => {
//     a.addEventListener('click', () => {
//         if (a.getAttribute('href').includes('#')) {
//             console.log(a)

//             lenis.scrollTo(a)
//         }
//     })
// })

const initHeaderScrollState = () => {
    const headerOffset = 200
    const body = document.body

    const setTopState = (isTop) => {
        body.classList.toggle('headroom--top', isTop)
        body.classList.toggle('headroom--not-top', !isTop)
        setTimeout(() => {
            ScrollTrigger.refresh()
        }, 500)
    }

    // setTopState(window.scrollY <= headerOffset)

    ScrollTrigger.create({
        start: '+=150',
        onEnter: () => setTopState(false),
        onLeaveBack: () => setTopState(true)

        // markers: true
    })
}

// App main
const main = async () => {
    const isQuotePage = document.querySelector('.page-quotes')
    if (isQuotePage == null) {
        initHeaderScrollState()
    }
    // Dit komt overeen met de twig var blockHandle
    // const blocks = []
    const components = [
        'fancybox',
        'swiper',
        'accordionComp',
        'langSwitcher',
        'googleMaps',
        'faq',
        'count',
        'plyr'
    ]

    const importPromises = []

    // for (const block of blocks) {
    //     const blockElements = document.querySelectorAll(`.${block}`)

    //     if (blockElements.length === 0) {
    //         continue
    //     }

    //     const importPromise = import(`./blocks/${block}.js`).then(
    //         ({ init }) => {
    //             blockElements.forEach((block) => {
    //                 importPromises.push(init(block))
    //             })
    //         }
    //     )

    //     importPromises.push(importPromise)
    // }

    for (const comp of components) {
        const compElements = document.querySelectorAll(`.${comp}`)
        if (compElements.length === 0) {
            continue
        }

        const importPromise = import(`./components/${comp}.js`).then(
            ({ init }) => {
                compElements.forEach((comp) => {
                    importPromises.push(init(comp, lenis))
                })
            }
        )

        importPromises.push(importPromise)
    }

    importPromises.push(
        import('./base/animations.js').then(({ initAnimations }) =>
            initAnimations()
        )
    )

    importPromises.push(
        import('./base/menu.js').then(({ initMenu }) => initMenu())
    )
    return await Promise.all(importPromises)
}

main().then(() => {
    console.log('Vite <3')
    window.Alpine = Alpine

    Alpine.plugin(collapse)
    Alpine.start()

    const anchor = getAnchor()
    if (anchor) {
        const anchorElement = document.querySelector(`#${anchor}`)
        if (anchorElement) {
            setTimeout(() => {
                console.log(window.innerWidth)
                lenis.scrollTo(anchorElement, {
                    offset: offset
                })
            }, 500)
        }
    }

    // const headerHeight = document.querySelector('header').offsetHeight
    // const main = document.querySelector('main')
    // if (headerHeight && main) {
    //     main.style.height = `${headerHeight}px`
    // }
})

const getAnchor = () => {
    var currentUrl = document.URL,
        urlParts = currentUrl.split('#')

    return urlParts.length > 1 ? urlParts[1] : null
}

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}
